import { useMutation, useQuery } from 'react-query'
import { notification } from 'antd'
import { useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { QUERY_KEYS } from '@api'
import { useUser } from '@contexts'
import { ROUTE_KEYS } from '@constants'

import { UsersApi } from './api'

interface Props {
  onSucces?: () => void
}

const useLoginResponseManager = (props?: Props) => {
  const { setState } = useUser()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { t } = useTranslation()

  const onError = () => {
    notification.error({
      message: t('we_couldnt_find_the_user'),
      duration: 3,
    })
  }

  const { mutate, isLoading } = useMutation([QUERY_KEYS.USER], UsersApi.getUser, {
    onError,
    onSuccess: ({ user }) => {
      setState(user)
      props?.onSucces?.()
      if (pathname.includes('/login') || pathname === '/') {
        navigate(ROUTE_KEYS[user.roles[0].name].HOME)
      }
    },
  })

  return { isLoading, onSucces: mutate }
}

const useUserResponseManager = (id: number | undefined) => {
  const {
    data: getUser,
    isLoading: userIsLoading,
    isFetching: userFetching,
  } = useQuery([QUERY_KEYS.USER], () => UsersApi.getUser(id), {
    enabled: !!id,
  })

  return { getUser, userIsLoading, userFetching }
}

export { useLoginResponseManager, useUserResponseManager }
